import Layout from '@/views/layout'
export default {
  path: '/vehicletravel',
  menuName: '车辆行程',
  component: Layout,
  redirect: 'noredirect',
  name: 'vehicletravel',
  meta: { title: 'vehicletravel', icon: 'car-trip', iconType: 'svg' },
  children: [
    {
      path: 'trip',
      name: 'trip',
      menuName: '行程记录',
      component: () => import('@/views/vehicletravel/trip'),
      meta: { title: 'trip', icon: 'trip', iconType: 'svg' }
    },
    {
      path: 'mileageStatistics',
      name: 'mileageStatistics',
      menuName: '车辆行程统计',
      component: () => import('@/views/vehicletravel/mileageStatistics'),
      meta: { title: 'mileageStatistics', icon: 'mileageStatistics', iconType: 'svg' }
    },
    {
      path: 'downloaddata',
      name: 'downloaddata',
      menuName: '历史数据下载',
      component: () => import('@/views/vehicletravel/downloadData'),
      meta: { title: 'downloaddata', icon: 'downloaddata', iconType: 'svg' }
    },
    {
      path: 'tripdownloadData',
      name: 'tripdownloadData',
      menuName: '行程数据下载',
      component: () => import('@/views/vehicletravel/tripdownloadData'),
      meta: { title: 'tripdownloadData', icon: 'downloaddata', iconType: 'svg' }
    }
  ]
}